import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=6ef9fd8e&scoped=true"
import script from "./Provider.vue?vue&type=script&lang=js"
export * from "./Provider.vue?vue&type=script&lang=js"
import style0 from "./Provider.vue?vue&type=style&index=0&id=6ef9fd8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef9fd8e",
  null
  
)

export default component.exports